import { render, staticRenderFns } from "./SsoModal.vue?vue&type=template&id=16a3e122&"
import script from "./SsoModal.vue?vue&type=script&lang=js&"
export * from "./SsoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports